import { UserCookie } from "models";
import React, { useEffect, useState } from "react";

export interface UserContextType {
    user: UserCookie | null | undefined;
    setUser: React.Dispatch<React.SetStateAction<UserCookie | null | undefined>>
}

export const UserContext = React.createContext<UserContextType | null | undefined>(null);

export const UserProvider = ({ children }: any) => {
    const [user, setUser] = useState<UserCookie | null | undefined>(() => {
        const storedData = localStorage.getItem('userContextData');
        if (storedData !== 'undefined') {
            return storedData ? JSON.parse(storedData) : null;
        }
        return null;
    });

    useEffect(() => {
        localStorage.setItem('userContextData', JSON.stringify(user));
    }, [user]);

    return (<UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>);
}